import { Fragment } from 'react';
import { notEmpty } from '@/lib/typescript-helpers';
import AlternatingFeatures from '@/components/_rebrand/craft/flex/AlternatingFeatures';
import { AlternatingFeaturesData } from '@/components/_rebrand/craft/flex/AlternatingFeatures/AlternatingFeatures.types';
import CustomerQuotes from '@/components/_rebrand/craft/flex/CustomerQuotes';
import { CustomerQuotesData } from '@/components/_rebrand/craft/flex/CustomerQuotes/CustomerQuotes.types';
import CompetitiveTable from '@/components/_rebrand/craft/product/CompetitiveTable';
import ThreeBenefits from '@/components/_rebrand/craft/product/ThreeBenefits';
import FAQ from '@/components/_rebrand/craft/product/FAQ';
import Bumper from '@/components/_rebrand/craft/flex/Bumper';
import ProductValidation from '@/components/_rebrand/craft/flex/ProductValidation';
import WhyFront from '@/components/_rebrand/craft/flex/WhyFront';
import FeatureExploration from '@/components/_rebrand/craft/flex/FeatureExploration';
import TabbedFeatures from '@/components/_rebrand/craft/flex/TabbedFeatures';
import AllFeatures from '@/components/_rebrand/craft/product/AllFeatures';
import FlexPageHero from '@/components/_rebrand/craft/flex/FlexPageHero';
import { FlexPageHeroData } from '@/components/_rebrand/craft/flex/FlexPageHero/FlexPageHero.types';
import BlockDivider from '@/components/_rebrand/craft/flex/BlockDivider';
import PaddedDivider from '@/components/_rebrand/craft/flex/PaddedDivider';

type ComparisonModule = {
  __typename: string;
  id?: string | null;
  [key: string]: unknown;
};

type ComparisonModulesRendererProps = {
  modules: (ComparisonModule | null | undefined)[] | null | undefined;
};

const ComparisonModulesRenderer = ({ modules }: ComparisonModulesRendererProps) => {
  if (!modules) {
    return null;
  }

  return (
    <Fragment>
      {modules.filter(notEmpty).map((block, index) => {
        const key = block.id ?? index;

        switch (block.__typename) {
          case 'comparisonModules_competitiveTable_BlockType': {
            const entryData = {
              moduleProductCompetitiveTable: block,
              moduleProductTheme: [{ color: 'pink' }],
            };

            return <CompetitiveTable key={key} entry={entryData} />;
          }

          case 'comparisonModules_threexBenefits_BlockType':
            return <ThreeBenefits key={key} entry={block} />;

          case 'comparisonModules_faq_BlockType':
            return <FAQ key={key} entry={block} />;

          case 'comparisonModules_bumper_BlockType':
            return <Bumper key={key} entry={block} />;

          case 'comparisonModules_g2Validation_BlockType':
            return <ProductValidation key={key} entry={block} />;

          case 'comparisonModules_whyFront_BlockType':
            return <WhyFront key={key} entry={block} />;

          case 'comparisonModules_featureExploration_BlockType':
            return <FeatureExploration key={key} entry={block} />;

          case 'comparisonModules_tabbedFeatures_BlockType':
            return <TabbedFeatures key={key} entry={block} />;

          case 'comparisonModules_allFeatures_BlockType':
            return <AllFeatures key={key} entry={block} />;

          case 'comparisonModules_pageHero_BlockType':
            return <FlexPageHero key={key} entry={block as unknown as FlexPageHeroData} />;

          case 'comparisonModules_blockDivider_BlockType':
            return <BlockDivider key={key} entry={block} />;

          case 'comparisonModules_solidPaddedDivider_BlockType':
            return <PaddedDivider key={key} entry={block} />;

          case 'comparisonModules_alternatingFeatureBlocks_BlockType':
            return <AlternatingFeatures key={key} entry={block as unknown as AlternatingFeaturesData} />;

          case 'comparisonModules_customerQuotes_BlockType':
            return <CustomerQuotes key={key} entry={block as unknown as CustomerQuotesData} />;

          default:
            return null;
        }
      })}
    </Fragment>
  );
};

export default ComparisonModulesRenderer;
